/// <amd-module name="Dashboards/DashboardView/src/model/LoadingStrategies" />
export enum LoadingStrategy {
    /* Start loading all the widgets at the same time, before TTI is marked */
    Immediate = "Dashboard.TTI.LegacyWidgetLoadingStrategy.Immediate",

    /* Start loading all modern widgets, then load legacy widgets after TTI is marked*/
    DeferLegacyWidgets = "Dashboard.TTI.LegacyWidgetLoadingStrategy.Deferred",

    /* Start loading fast modern widgets and legacy widgets, then load slow modern widgets after TTI is marked */
    DeferSlowModernWidgets = "Dashboard.TTI.WidgetLoadingStrategy.DeferSlowModernWidgets",

    /* Start loading fast modern widgets, then load slow modern widgets and legacy widgets after TTI is marked */
    DeferLegacyAndSlowModernWidgets = "Dashboard.TTI.WidgetLoadingStrategy.DeferLegacyAndSlowModernWidget"
}
